import { Card, CardContent } from "@/components/ui/card";

interface ProgressBarProps {
  current: number;
  total: number;
  reviewedCount: number;
  correctCount: number;
  incorrectCount: number;
  skippedCount: number;
  timeElapsed: number; // in minutes
  reviewsPerHour: number;
}

export default function ProgressBar({
  current,
  total,
  reviewedCount,
  correctCount,
  incorrectCount,
  skippedCount,
  timeElapsed,
  reviewsPerHour,
}: ProgressBarProps) {
  const percentage = total > 0 ? Math.round((reviewedCount / total) * 100) : 0;
  const remaining = total - reviewedCount;

  return (
    <Card className="mb-6">
      <CardContent className="pt-6">
        <div className="space-y-4">
          {/* Main Progress Bar */}
          <div>
            <div className="flex justify-between text-sm text-gray-600 mb-2">
              <span>
                District {current + 1} of {total}
              </span>
              <span>{percentage}% Complete</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-3">
              <div
                className="bg-blue-600 h-3 rounded-full transition-all duration-300"
                style={{ width: `${percentage}%` }}
              ></div>
            </div>
          </div>

          {/* Stats Grid */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 pt-2">
            <div className="text-center">
              <div className="text-2xl font-bold text-gray-900">
                {reviewedCount}
              </div>
              <div className="text-sm text-gray-500">Reviewed</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-green-600">
                {correctCount}
              </div>
              <div className="text-sm text-gray-500">Correct</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-red-600">
                {incorrectCount}
              </div>
              <div className="text-sm text-gray-500">Incorrect</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-yellow-600">
                {skippedCount}
              </div>
              <div className="text-sm text-gray-500">Skipped</div>
            </div>
          </div>

          {/* Session Stats */}
          <div className="flex justify-between text-sm text-gray-600 pt-2 border-t">
            <span>{remaining} remaining</span>
            <span>{timeElapsed}m elapsed</span>
            <span>{reviewsPerHour} reviews/hour</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
